import React from 'react';
import { BookOpen, Quote, Sparkles } from 'lucide-react';
import { expectItems } from '../mock';

const iconMap = { BookOpen, Quote, Sparkles };

export default function WhatToExpect() {
  return (
    <section className="relative border-t border-black/5 bg-[#F5F2EC]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14 py-20 md:py-28">
        <div className="text-[10px] tracking-[0.28em] uppercase text-neutral-500 mb-5">
          What to expect
        </div>

        <div className="grid md:grid-cols-3 gap-8 items-end mb-14">
          <h2 className="md:col-span-2 font-serif text-[40px] md:text-[56px] leading-[1.02] tracking-[-0.02em] text-neutral-900">
            Real stories. <span className="italic text-neutral-500">Real founders.</span>
          </h2>
          <p className="text-neutral-600 text-[15px] leading-relaxed max-w-sm">
            Curated, long-form, and refreshingly free of LinkedIn-flavored
            advice.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5 md:gap-6">
          {expectItems.map((item, i) => {
            const Icon = iconMap[item.icon];
            const isDark = item.dark;
            return (
              <div
                key={item.num}
                className={`group relative rounded-md p-8 md:p-9 border transition-all duration-500 hover:-translate-y-1 ${
                  isDark
                    ? 'bg-neutral-900 border-neutral-900 text-[#F5F2EC] shadow-lg hover:shadow-2xl'
                    : 'bg-white border-black/5 text-neutral-900 shadow-sm hover:shadow-md'
                }`}
                style={{ animationDelay: `${0.1 * i}s` }}
              >
                <div
                  className={`w-10 h-10 rounded-sm flex items-center justify-center mb-16 ${
                    isDark
                      ? 'bg-white/10 text-[#F5F2EC]'
                      : 'bg-neutral-900 text-[#F5F2EC]'
                  }`}
                >
                  <Icon className="w-5 h-5" strokeWidth={1.6} />
                </div>
                <div
                  className={`text-[10px] tracking-[0.28em] uppercase mb-3 ${
                    isDark ? 'text-neutral-500' : 'text-neutral-500'
                  }`}
                >
                  {item.num} · {item.label}
                </div>
                <h3 className="font-serif text-[22px] md:text-[24px] leading-tight mb-3 tracking-tight">
                  {item.title}
                </h3>
                <p
                  className={`text-[14.5px] leading-relaxed ${
                    isDark ? 'text-neutral-300' : 'text-neutral-600'
                  }`}
                >
                  {item.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
